function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.355 2.467V0H2.474C1.174 0 .107.997.018 2.278L0 11.508c0 1.798 1.62 3.382 3.488 3.382h9.113c1.868 0 3.399-1.46 3.399-3.275V5.511c-.053-1.744-1.495-3.044-3.435-3.044h-1.21zM10.309.917v1.82h-7.69c-.57-.058-1.015-.442-1.015-.897 0-.511.516-.924 1.157-.924h7.548zm2.256 12.638H3.453c-1.122 0-2.154-.979-2.154-2.046V3.518c.267.142.57.23.89.267.09 0 .16.017.25.017v-.017h10.09c.997 0 2.065.533 2.065 1.708v.605h-2.047a2.43 2.43 0 00-2.438 2.438 2.43 2.43 0 002.438 2.439h2.083v.605c0 1.103-.926 1.975-2.065 1.975zm2.065-4.004v.107h-2.083a1.11 1.11 0 01-1.103-1.104 1.11 1.11 0 011.103-1.103h2.083v2.1z",
  fill: "currentColor"
});

function SvgHighprice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHighprice;